import React from 'react';
import { Heart, Instagram, Facebook, Youtube } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4 md:col-span-2">
            <div className="flex items-center gap-2">
              <Heart className="w-6 h-6 fill-white" />
              <span className="text-lg font-['Montserrat'] font-light tracking-[0.2em] uppercase">Sagar Sen Photography</span>
            </div>
            <p className="text-gray-400 max-w-md">
              Capturing timeless moments and authentic emotions. Professional wedding photographer
              specializing in pre-wedding, ceremony, and candid photography.
            </p>
            {/* Social Media */}
            <div className="flex gap-4 pt-4">
              <a
                href="https://www.instagram.com/sagar_sen_photography/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/fotokraftphotography/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/@sagrsen"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-red-600 rounded-lg flex items-center justify-center transition-all duration-300"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#albums" className="hover:text-white transition-colors">Albums</a>
              </li>
              <li>
                <a href="#videos" className="hover:text-white transition-colors">Videos</a>
              </li>
              <li>
                <a href="#gallery" className="hover:text-white transition-colors">Gallery</a>
              </li>
              <li>
                <a href="#about" className="hover:text-white transition-colors">About Us</a>
              </li>
              <li>
                <a href="#blog" className="hover:text-white transition-colors">Blog</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-white transition-colors">Contact</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Wedding Photography</li>
              <li>Pre-Wedding Shoots</li>
              <li>Engagement Sessions</li>
              <li>Candid Photography</li>
              <li>Cinematic Films</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 text-center text-gray-400">
          <p>
            &copy; {currentYear} Sagar Sen Photography. All rights reserved.
            {' '}
            <span className="inline-block">Made with</span>
            {' '}
            <Heart className="w-4 h-4 inline fill-red-500 text-red-500" />
            {' '}
            <span className="inline-block">for capturing love stories</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

